(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[470],{

/***/ 24847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/YCS21/index.tsx








function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "Albert Chuang",
      dateTime: "2021-06-24",
      tag: "Funding",
      title: "OneShop joins Y Combinator\u2019s Summer 2021 Batch",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        src: "/static/images/yc-s21-og-image.png?v=1",
        width: 1310,
        height: 655,
        alt: "YC",
        loading: "eager"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Both", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://linkedin.com/in/aaronptb",
          target: "_blank",
          children: "Aaron"
        }), ' ', "and", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://linkedin.com/in/yonajune",
          target: "_blank",
          children: "I"
        }), ' ', "are excited to share that OneShop is part of", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://ycombinator.com",
          target: "_blank",
          children: "Y Combinator"
        }), "\u2019s summer batch this year."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "OneShop is making selling on e-commerce marketplaces easier. We\u2019re building listing, marketing, and analytics tools for sellers so they can more effectively run their business on marketplaces like Poshmark and Mercari."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Being part of Y Combinator has materially improved how we're building OneShop and given us a much-needed period of time to focus on better serving our customers."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Twice a year, the Silicon Valley based firm aims to fund the next generation of category-defining companies. Its portfolio has a combined valuation of $300B. Some notable alumni include Airbnb, DoorDash, Instacart, Dropbox, and Coinbase."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["We're also hiring software engineers! If you\u2019re interested you can email Albert at", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "mailto:albert@oneshop.com",
          target: "_blank",
          children: "albert@oneshop.com"
        }), ' ', "and view our openings on the", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://www.workatastartup.com/companies/oneshop",
          target: "_blank",
          children: "Work at a Startup job board"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/yc-s21.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "OneShop joins Y Combinator\u2019s Summer 2021 Batch | OneShop Blog"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "OneShop helps sellers sell on marketplaces."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/yc-s21"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/yc-s21"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "OneShop joins Y Combinator\u2019s Summer 2021 Batch | OneShop Blog"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "OneShop helps sellers sell on marketplaces."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/yc-s21-og-image.png?v=1"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2021-06-24T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2021-06-24T00:00:00.000Z"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Fundraising"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 64656:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/yc-s21",
      function () {
        return __webpack_require__(24847);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(64656); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);